import { Backdrop, CircularProgress, makeStyles } from "@mui/material";
import React from "react";

// const useStyles = makeStyles((theme) => ({
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: "#fff",
//   },
//   closeIcon: {
//     color: "#fff",
//     float: "right",
//     margin: "-8px",
//   },
// }));

export default function CustomPageLoading() {
  // const classes = useStyles();

  return (
    <Backdrop sx={{ zIndex: "99" }} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
